(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moro-brand-transitions"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scenicPath = path => ['/', '/collections', '/products', '/pages/storia', '/pages/storia/', '/pages/la-storia-del-leone-piu-famoso-del-mondo', '/pages/la-storia-del-leone-piu-famoso-del-mondo/'].includes(path) || path.startsWith('/collections/') || path.startsWith('/products/');
    const listenForCancellation = transition => {
      const cancel = () => transition.skipTransition();
      const options = { once: true, passive: true };
      const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
      events.forEach(name => window.addEventListener(name, cancel, options));
      transition.finished.finally(() => {
        events.forEach(name => window.removeEventListener(name, cancel));
      });
    };
    window.addEventListener('pageswap', event => {
      if (!event.viewTransition) return;
      const destination = event.activation?.entry?.url;
      let eligible = false;
      if (destination) {
        const url = new URL(destination);
        eligible = url.origin === location.origin &&
          scenicPath(location.pathname) && scenicPath(url.pathname) &&
          url.pathname !== location.pathname;
      }
      if (!eligible || reducedMotion.matches) event.viewTransition.skipTransition();
    });
    window.addEventListener('pagereveal', event => {
      if (!event.viewTransition) return;
      if (!scenicPath(location.pathname) || reducedMotion.matches) {
        event.viewTransition.skipTransition();
        return;
      }
      listenForCancellation(event.viewTransition);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
